import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-793a256e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CarrierId" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center flex-col bg-white border px-6 py-4"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-sm mt-2" }, "Загрузка данных о курьере...", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 text-sm" }, " При получении данных о курьере произошла ошибка ", -1))
const _hoisted_9 = {
  key: 1,
  class: "grid grid-cols-3 gap-3 bg-white border px-6 py-4"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "БИН", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Контактное имя", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Контактный номер", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Номер договора", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Дата договора", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Тип поставщика", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Дата создания", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Номер заявки Jira", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "С НДС", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "ОКЭД", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_history = _resolveComponent("history")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_page_title, { title: _ctx.getTitle }, null, 8, ["title"]),
        (_ctx.state.carrier)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: "small ml-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.carrier.status), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.state.is_loading || _ctx.state.is_failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_7
                ], 64))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_8,
                    _createVNode(_component_the_button, {
                      class: "primary small text mt-3",
                      onClick: _ctx.loadCarrier
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перезагрузить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.carrier.bin || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.carrier.contact_name || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_12,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.carrier.contact_phone || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_13,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.carrier.contract_number || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_14,
              _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.carrier.contract_date) || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_15,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.carrier.activity
                                    ? _ctx.getActivityString(_ctx.state.carrier.activity)
                                    : '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_16,
              _createElementVNode("p", null, [
                (_ctx.state.carrier.created_at)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.state.carrier.created_at.replaceAll('-', '.')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_17,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.carrier.jira_ticket || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_18,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.carrier.is_nds ? 'Да' : 'Нет'), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_19,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.carrier.economy_classifier || '-'), 1)
            ])
          ])),
      (_ctx.isHistory)
        ? (_openBlock(), _createBlock(_component_history, {
            key: 2,
            class: "mt-6",
            identifier: _ctx.state.carrier.bin,
            type: 1
          }, null, 8, ["identifier"]))
        : _createCommentVNode("", true)
    ])
  ]))
}